'use server'

import { env } from '@repo/shared-server/env'
import { createServerFn } from '@tanstack/react-start'

export const getMapboxToken = createServerFn({ method: 'GET' }).handler(() => {
  return env.MAPBOX_API_TOKEN
})
